import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Box } from "@mui/material";
import {Fingerprint , CheckBox , NotInterested , Delete} from "@mui/icons-material";
import { ContentCopyOutlined, TableChartOutlined, DescriptionOutlined, PictureAsPdfOutlined, FileDownloadOutlined } from "@mui/icons-material";
import { DataGrid ,GridToolbarContainer, GridToolbarDensitySelector, } from "@mui/x-data-grid";
import { GridToolbarQuickFilter } from '@mui/x-data-grid';
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useSelector , useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import _ from "lodash";

//Services
import DriverApi from "Services/Driver";

//Modals
import DriverAddModal from "Pages/Modals/Driver/Create";
import DriverUpdateModal from "Pages/Modals/Driver/Update";
import DriverDeleteModal from "Pages/Modals/Driver/Delete";

const Driver = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const subcmpnyName = useSelector(
      (state) => state?.AuthReducer?.subCmpny || ""
    );
  const [searchText, setSearchText] = useState("");
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);   
  const [driverId, setDriverId] = useState("");
  const [drivermodelId, setDrivermodelId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  /**
   * Modals
   */

  // Driver add modal

  const [addDriverModal, setAddDriverModal] = useState(false);

  const handleOpenAddDriverModal = () => {
    setAddDriverModal(true);
  };

  const handleCloseAddDriverModal = () => {
    setAddDriverModal(false);
    getDrivers();
  };

  // Driver update modal

  const [updateDriverModal, setDriverUpdateModal] = useState(false);

  const handleOpenUpdateDriverModal = (row) => {
    setDriverId(row?._id);
    setDriverUpdateModal(true);
  };

  const handleCloseUpdateDriverModal = () => {
    setDriverUpdateModal(false);
    getDrivers();
  };

  // Driver update modal

  const [DeleteDriverModal, setDriverDeleteModal] = useState(false);

  const handleOpenDeleteDriverModal = (row) => {
    //console.log('row--->',row);
    setDriverId(row?._id);
    setDrivermodelId(row?.driver_ride_details?._id);
    setDriverDeleteModal(true);
  };

  const handleCloseDeleteDriverModal = () => {
    setDriverDeleteModal(false);
    getDrivers();
  };
  
  // Get Drivers list api

  const getDrivers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        //console.log('drivers-->',res?.data?.data?.data);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    DriverApi.getDriverList({ page, limit: pageSize , search: searchText}).then(
      onSuccess,
      onFailure
    );
  }, [page, pageSize ,searchText]);


  const getAllDrivers = useCallback(() => {
  //  dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    DriverApi.getDriverList({ page:1, limit: "unlimited" , search: ""}).then(
      onSuccess,
      onFailure
    );
  }, []);

  useEffect(() => {
    getDrivers();
    getAllDrivers();
  }, [getDrivers]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All DriverList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
    // Define column widths
    const columnWidths = [5, 15, 25, 15, 15, 15, 15, 15]; // Adjust widths as needed
  
    // Helper function to pad text to the desired width
    const padText = (text, width) => {
      return (text ?? "").toString().padEnd(width, " ");
    };
    // Create table header
    const header = [
      padText("S.NO", columnWidths[0]),
      padText("User Name", columnWidths[1]),
      padText("Email", columnWidths[2]),
      padText("Mobile", columnWidths[3]),
      padText("Total Requests", columnWidths[4]),
      padText("Accepted Requests", columnWidths[5]),
      padText("Cancelled Requests", columnWidths[6]),
      padText("Account Status", columnWidths[7]),
    ].join("");
  
    // Create table rows
    const rows = dataRows
      .map((row) =>
        [
          padText(row.sno, columnWidths[0]),
          padText(row.userName, columnWidths[1]),
          padText(row.email, columnWidths[2]),
          padText(row.mobile, columnWidths[3]),
          padText(row.total_requests, columnWidths[4]),
          padText(row.accepted_requests, columnWidths[5]),
          padText(row.cancelled_requests, columnWidths[6]),
          padText(row.accountStatus, columnWidths[7]),
        ].join("")
      )
      .join("\n");
  
    // Combine header and rows
    const formattedContent = [header, rows].join("\n");
  
    // Copy to clipboard
    navigator.clipboard.writeText(formattedContent).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "DriverList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "DriverList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,row.userName,row.email,
     row.mobile,row.total_requests,row.accepted_requests,
  row.cancelled_requests,row.accountStatus,
         
]);
    doc.autoTable({
head: [["S.NO","User Name","Email","Mobile","Total requests","Accepted requests","Cancelled requests","Account status"]],
body: tableData,
    });
    doc.save("DriverList.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };


  function CustomToolbar() {
    return (
<Box sx={{ p: 1, pb: 0, display: "flex", justifyContent: "flex-start" }}>
<GridToolbarQuickFilter debounceMs={800} autoFocus/>
<GridToolbarContainer>
<GridToolbarDensitySelector />
</GridToolbarContainer>
</Box>
    );
  }

  const filteredRows = (row || []).filter((data) => {
    // console.log('userType--->',userType)
    // console.log('subcmpnyName--->',subcmpnyName)
    if (userType === "SUB COMPANY" && subcmpnyName) {
      console.log(data);
      
      return data?.sub_companyName === subcmpnyName;
    }
    return true; // For other user types, include all
  });

  const dataRows = filteredRows.map((data, index) => ({
    id: index+1,
    sno: calculateSno(page, pageSize, index),
    userName: data?.firstName+" "+data?.lastName,
    email: data?.email,
    mobile: data?.countryCode+" "+data?.mobileNumber,
    total_requests: data?.driver_ride_details?.total_requests?.length,
    accepted_requests: data?.driver_ride_details?.accepted_requests?.length,
    cancelled_requests: data?.driver_ride_details?.cancelled_requests?.length,
    accountStatus:data?.driver_ride_details?.accountStatus,
    row: data, 
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      minWidth: 10, // Minimum column width
      resizable: true, // Allow users to resize
        sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "userName",
      headerName: "User Name",
      minWidth: 150, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.userName}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.email}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      minWidth: 150, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.mobile}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "total_requests",
      headerName: "Total requests",
      minWidth: 120, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Typography variant="body2">{params?.row?.total_requests}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "cancelled_requests",
      headerName: "Cancelled requests",
      minWidth: 155, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Typography variant="body2">{params?.row?.cancelled_requests}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "accepted_requests",
      headerName: "Accepted Requests",
      minWidth: 145, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div style={{ textAlign: "center", width: "100%" }}>
              <Typography variant="body2">{params?.row?.accepted_requests}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Documents / Service Type",
      minWidth: 200, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
      const { accountStatus } = params.row; 
      const isApproved = accountStatus === "APPROVED";
      const isBanned = accountStatus === "BANNED";
      const statusLabel = accountStatus || "ONBOARDING";
      const statusBg = isApproved ? "#4CAF50" : isBanned ? "#E53935" : "#FB8C00";
      const statusIcon = isApproved ? <CheckBox /> : isBanned ? <NotInterested /> : <Fingerprint />;

       return (
       <>
<div className={classes.iconsWrapper}>
  <section className={classes.editIcon}>
    <Button
      variant="contained"
      startIcon={statusIcon}
      onClick={() => handleOpenUpdateDriverModal(params?.row?.row)}
      sx={{
        backgroundColor: `${statusBg} !important`,
        color: "#fff !important",
        borderRadius: "8px",
        px: 2,
        py: 0.9,
        minWidth: 160,
        fontWeight: 700,
        boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
        "& .MuiSvgIcon-root": { color: "#fff !important" },
        "&:hover": { backgroundColor: `${statusBg} !important`, opacity: 0.95 },
      }}
    >
      {statusLabel}
    </Button>
  </section>
</div>
</>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      minWidth: 20, // Minimum column width
      resizable: true, // Allow users to resize
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
       return (
       <>
   <Button
        variant="contained"
        sx={{
          minWidth: "52px",
          height: "46px",
          backgroundColor: "#FDECEF !important",
          border: "1px solid #F3CBD4",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
          "& .MuiSvgIcon-root": { color: "#FF2B78 !important", fontSize: 24 },
          "&:hover": { backgroundColor: "#FDECEF !important", opacity: 0.95 },
        }}
        onClick={() => handleOpenDeleteDriverModal(params?.row?.row)}
      >
        <Delete />
      </Button> 
</>

        );
      },
    },
  ];

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "User Name":row.userName,
    "Email":row.email,
    "Mobile": row.mobile,
    "Total requests": row.total_requests,
    "Accepted requests": row.accepted_requests,
    "Cancelled requests": row.cancelled_requests,
    "Account status": row.accountStatus,
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
   sno: calculateSno(page, pageSize, index),
    userName: data?.firstName+" "+data?.lastName,
    email: data?.email,
    mobile: data?.countryCode+" "+data?.mobileNumber,
    total_requests: data?.driver_ride_details?.total_requests?.length,
    accepted_requests: data?.driver_ride_details?.accepted_requests?.length,
    cancelled_requests: data?.driver_ride_details?.cancelled_requests?.length,
    accountStatus:data?.driver_ride_details?.accountStatus,
    row: data, 
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
   "S.NO": row.sno,
    "User Name":row.userName,
    "Email":row.email,
    "Mobile": row.mobile,
    "Total requests": row.total_requests,
    "Accepted requests": row.accepted_requests,
    "Cancelled requests": row.cancelled_requests,
    "Account status": row.accountStatus,
  }));  

  return (
    <>
      <Grid container className={classes.root}>

<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" startIcon={<ContentCopyOutlined />} onClick={handleCopy}>
      COPY
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" startIcon={<TableChartOutlined />} onClick={handleDownloadExcel}>
      EXCEL
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" startIcon={<DescriptionOutlined />} onClick={handleDownloadCSV}>
      CSV
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" startIcon={<PictureAsPdfOutlined />} onClick={handleDownloadPDF}>
      PDF
    </Button>
  </Grid>
      <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
      <Button variant="contained" startIcon={<FileDownloadOutlined />} onClick={handleDownloadAll}>
      Download ALL
      </Button>
      </Grid>      
  <Grid item xs={6} md={6} lg={6} xl={6} className={classes.addBtn}>
    <Button variant="contained" onClick={handleOpenAddDriverModal}>
      Add Driver
    </Button>
  </Grid>

  <Grid item xs={12}>
    <section className={classes.dataGridTable}>
      <DataGrid
        //getRowId={(row) => row?.row?._id}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={70}
        style={{ padding: "10px", borderRadius: "0px", overflowX: "auto" }}
        paginationMode="server" 
        rowCount={totalPages}
        filterMode="server"
        onFilterModelChange={(model) => {
        const value = model?.quickFilterValues?.join(" ") || "";
       // console.log(value);
        setSearchText(value);          
        }}        
        density="compact"
        components={{
          Toolbar:CustomToolbar,
        }}
      />
    </section>
  </Grid>

      </Grid>
      <DriverAddModal
        openDialog={addDriverModal}
        handleClose={handleCloseAddDriverModal}
      ></DriverAddModal>
      <DriverUpdateModal
        openDialog={updateDriverModal}
        handleClose={handleCloseUpdateDriverModal}
        driverId={driverId}
      ></DriverUpdateModal>
        <DriverDeleteModal
        openDialog={DeleteDriverModal}
        handleClose={handleCloseDeleteDriverModal}
        driverId={driverId}
        drivermodelId={drivermodelId}
      ></DriverDeleteModal>
    </>
  );
};

export default Driver;
